// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/utils/provider/theme-provider.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$(),
  _s3 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/utils/provider/theme-provider.tsx");
  import.meta.hot.lastModified = "1723812797000";
}
// REMIX HMR END

import { useFetcher } from '@remix-run/react';
import { createContext, useContext, useEffect, useRef, useState } from 'react';
var Theme = /*#__PURE__*/function (Theme) {
  Theme["DARK"] = "dark";
  Theme["LIGHT"] = "light";
  return Theme;
}(Theme || {});
const themes = Object.values(Theme);
const ThemeContext = createContext(undefined);
const prefersLightMQ = '(prefers-color-scheme: light)';
const getPreferredTheme = () => window.matchMedia(prefersLightMQ).matches ? Theme.LIGHT : Theme.DARK;
function ThemeProvider({
  children,
  specifiedTheme
}) {
  _s();
  const [theme, setTheme] = useState(() => {
    // On the server, if we don't have a specified theme then we should
    // return null and the clientThemeCode will set the theme for us
    // before hydration. Then (during hydration), this code will get the same
    // value that clientThemeCode got so hydration is happy.
    if (specifiedTheme) {
      if (themes.includes(specifiedTheme)) {
        return specifiedTheme;
      } else {
        return null;
      }
    }

    // there's no way for us to know what the theme should be in this context
    // the client will have to figure it out before hydration.
    if (typeof window !== 'object') {
      return null;
    }
    return getPreferredTheme();
  });
  const persistTheme = useFetcher();
  const mountRun = useRef(false);
  useEffect(() => {
    if (!mountRun.current) {
      mountRun.current = true;
      return;
    }
    if (!theme) {
      return;
    }
    persistTheme.submit({
      theme
    }, {
      action: 'action/set-theme',
      method: 'post'
    });
  }, [theme]);
  useEffect(() => {
    const mediaQuery = window.matchMedia(prefersLightMQ);
    const handleChange = () => {
      setTheme(mediaQuery.matches ? Theme.LIGHT : Theme.DARK);
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);
  return <ThemeContext.Provider value={[theme, setTheme]}>
      {children}
    </ThemeContext.Provider>;
}
_s(ThemeProvider, "HvCsGFptcr9MC8H2FgNl6e6mzA4=", false, function () {
  return [useFetcher];
});
_c = ThemeProvider;
const clientThemeCode = `
// hi there dear reader 👋
// this is how I make certain we avoid a flash of the wrong theme. If you select
// a theme, then I'll know what you want in the future and you'll not see this
// script anymore.
;(() => {
  const theme = window.matchMedia(${JSON.stringify(prefersLightMQ)}).matches
    ? 'light'
    : 'dark';

  const cl = document.documentElement.classList;

  const themeAlreadyApplied = cl.contains('light') || cl.contains('dark');
  if (themeAlreadyApplied) {
    // this script shouldn't exist if the theme is already applied!
    console.warn(
      "Hi there, could you let Matt know you're seeing this message? Thanks!",
    );
  } else {
    cl.add(theme);
  }

  const meta = document.querySelector('meta[name=color-scheme]');
  if (meta) {
    if (theme === 'dark') {
      meta.content = 'dark light';
    } else if (theme === 'light') {
      meta.content = 'light dark';
    }
  } else {
    console.warn(
      "Hey, could you let Matt know you're seeing this message? Thanks!",
    );
  }
})();
`;
function NonFlashOfWrongThemeEls({
  ssrTheme,
  nonce
}) {
  _s2();
  const [theme] = useTheme();
  return <>
      {/*
        On the server, "theme" might be `null`, so clientThemeCode ensures that
        this is correct before hydration.
       */}
      <meta name="color-scheme" content={theme === 'light' ? 'light dark' : 'dark light'} />
      {/*
        If we know what the theme is from the server then we don't need
        to do fancy tricks prior to hydration to make things match.
       */}
      {ssrTheme ? null : <script nonce={nonce}
    // NOTE: we cannot use type="module" because that automatically makes
    // the script "defer". That doesn't work for us because we need
    // this script to run synchronously before the rest of the document
    // is finished loading.
    dangerouslySetInnerHTML={{
      __html: clientThemeCode
    }} />}
    </>;
}
_s2(NonFlashOfWrongThemeEls, "tTTAODy8wohSLSpq8pa8WNTieJI=", false, function () {
  return [useTheme];
});
_c2 = NonFlashOfWrongThemeEls;
function useTheme() {
  _s3();
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
_s3(useTheme, "b9L3QQ+jgeyIrH0NfHrJ8nn7VMU=");
function isTheme(value) {
  return typeof value === 'string' && themes.includes(value);
}
export { isTheme, NonFlashOfWrongThemeEls, Theme, ThemeProvider, useTheme };
var _c, _c2;
$RefreshReg$(_c, "ThemeProvider");
$RefreshReg$(_c2, "NonFlashOfWrongThemeEls");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;